// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { RelationOut } from './relationOut.zod.ts';

export const RelationsOut = zod.object({
  "relations": zod.array(RelationOut),
  "revision": zod.int()
});

export type RelationsOut = zod.input<typeof RelationsOut>;
export type RelationsOutOutput = zod.output<typeof RelationsOut>;
